<template>
  <div class="order-container">
  	<header>{{msg}}</header>
  	<div class="formbox">
    <div class="order-tit">三叶儿童口腔-快速预约</div>
    <form @submit.prevent="submit">
    <ul>
      <li><label for="J_Name">患者姓名：</label><input type="text" id="J_Name" v-model="user.patientname" v-on:blur="distributeType('name')" maxlength="15" placeholder="用于就诊信息调用,务必正确填写"/></li>
      <li><label for="J_Tel">联系方式：</label><input type="text" id="J_Tel" v-model="myInfo.tel" v-on:blur="distributeType('phone')"   readonly onfocus="javascript:this.blur();"/></li>
      <li><label for="J_Age">患者年龄：</label><input type="text" id="J_Age" v-model="user.age" v-on:blur="distributeType('age')" maxlength="3" placeholder="请填写年龄，1岁以下填写为1"/></li>
      <li><label>就医时间：</label><input type="text" id="J_Date" value="" placeholder="请选择就医时间" readonly onfocus="javascript:this.blur();"/></li>
    	<li>
    	<label>期望医院：</label>
    	<select id="J_HospitalList">
            <option v-for="item in hospitalItems" :value="item.hospitalid">{{item.hospitalname}}</option>
    	</select>
      <b><img src="../assets/arrow_down.png" /></b>
    	</li>
      <li>
      <label>病症选择：</label>
      <select id="J_DiseaseList">
            <option v-for="item in diseaseItems" :value="item.diseaseid">{{item.diseasename}}</option>
      </select>
      <b><img src="../assets/arrow_down.png" /></b>
      </li>
    	<li>
      <label>备　　注：</label>
            <textarea id="J_Remark" v-model="user.remark" maxlength="200"></textarea>
      </li>
    	<li><div class="btn"><input type="submit" id="J_OrderBtn" value="预约"/></div></li>
    </ul>
    </form>
 </div>
    <DownloadApp></DownloadApp>

    <div id="J_ErrorTip" class="error-tip"></div>
    <MenuFooters :isHide="isHide" :menuType="currentMenuType"></MenuFooters>

  </div>
</template>
<script>
import Vue from 'vue';
import axios from 'axios';
import { setSid, getSid } from '../utils/SidManager';
import getConfig from '../utils/config';
import {getUrl} from '../utils/WebRequest';
import DownloadApp from './DownloadApp';
var config = getConfig();
import MenuFooters from './Footer'


export default {
  name: 'OrderSanye',
  components: {
      DownloadApp,
      MenuFooters
    },
  data () {
    const self = this;
    return {
      msg: '茄子会',
      currentMenuType: 'order',
      isHide:false,
      login:{sid: getSid()},
      myInfo:{},
      user:{patientname:'',age:'',remark:''},
      hospitalid: '',
      hospitalItems: [],
      illness:'',
      diseaseItems:[],
      diseaseItemsList:[
                        {"diseaseid":"牙科检查","diseasename":"牙科检查"},
                        {"diseaseid":"涂氟","diseasename":"涂氟"},
                        {"diseaseid":"窝沟封闭","diseasename":"窝沟封闭"},
                        {"diseaseid":"龋齿","diseasename":"龋齿"},
                        {"diseaseid":"儿童补牙","diseasename":"儿童补牙"},
                        {"diseaseid":"儿童拔牙","diseasename":"儿童拔牙"},
                        {"diseaseid":"儿童洗牙","diseasename":"儿童洗牙"},
                        {"diseaseid":"矫正(牙齿不齐)","diseasename":"矫正(牙齿不齐)"},
                        {"diseaseid":"其他","diseasename":"其他"}
                      ]
    }
  },

  methods: {
            getHospitalList: function() {
                return new Promise((resolve, reject) => {
                  axios.get(getUrl(config.url_map.queryHospitalsOfsanye))
                    .then((res) => {
                      const { bizobj, status } = res.data;
                      const { error_code, error_msg } = status;
                      if (error_code === 0) {
                        resolve(bizobj);
                      } else {
                        reject(error_msg);
                      }
                    });
                });
              },

            initHospitalSelect: function() {
              const $hospitalList = $('#J_HospitalList');
              $hospitalList.mobiscroll().select({
                theme: 'android-holo-light',
                mode: 'scroller',
                display: 'bottom',
                lang: 'zh'
              });
              const $hospitalListDummy = $('#J_HospitalList_dummy');
              $hospitalListDummy.attr("placeholder","请选择期望医院");
            },

            setHospital:function(){
              this.getHospitalList().then((hospitalList)=>{
                  this.hospitalItems=hospitalList;
                  this.initHospitalSelect();
              })
            },


            initDiseaseSelect: function() {//初始化病症下拉框
              this.diseaseItems=this.diseaseItemsList;
              const $diseaseList = $('#J_DiseaseList');

              $diseaseList.mobiscroll().select({
                theme: 'android-holo-light',
                mode: 'scroller',
                display: 'bottom',
                lang: 'zh'
              });
              const $diseaseListDummy = $('#J_DiseaseList_dummy');
              $diseaseListDummy.attr("placeholder","请选择相关病症");
            },

          errorTip: function($target, tip) {
            $target.show();
            $target.text(tip);

            setTimeout(function() {
                $target.removeClass('error-tip');
                $target.addClass('error-tip-fade');

                setTimeout(function() {
                    $target.removeClass('error-tip-fade');
                    $target.addClass('error-tip');

                    $target.hide();
                }, 500);
            }, 2000);
          },

          getStrLen: function(str){
              return str.replace(/[^\x00-\xff]/g, '__').length; //这个把所有双字节的都给匹配进去了
          },

          validateName: function($name, $tip, flag){
              var result = false;
              if($.trim($name.val()) === '' || !(/^[\u4e00-\u9fa5a-zA-Z0-9]+$/g.test($.trim($name.val())))){
                  var tip = '';
                  if(flag === 'realName'){
                      tip = '姓名为数字、字母或中文';
                  }else{
                      tip = '昵称为数字、字母或中文';
                  }

                  this.errorTip($tip,tip);

                  result = false;
              }else if(this.getStrLen($.trim($name.val())) > 15){
                  var tip = '';
                  if(flag === 'realName'){
                      tip = '姓名最多15个字符';
                  }else{
                      tip = '昵称最多15个字符';
                  }

                  this.errorTip($tip,tip);

                  result = false;
              }else{
                  result = true;
              }
              return result;
          },

        validatePhone: function($phone, $tip, tip) {
            var result = false;
            if ($.trim($phone.val()) === '' || !(/^(13[0-9]|14[0-9]|15[012356789]|18[0-9]|17[0-9])\d{8}$/.test($.trim($phone.val())))) {
                this.errorTip($tip, tip);

                result = false;
            } else {
                result = true;
            }
            return result;
        },

        validateAge: function($age, $tip, tip) {
            var result = false;
            if ($.trim($age.val()) === '' || !(/^(?:[1-9]\d?|1[0-4]\d|100)$/.test($.trim($age.val())))) {//1-100岁
                this.errorTip($tip, tip);

                result = false;
            } else {
                result = true;
            }
            return result;
        },

        validateEmpty: function($codeInput, $tip, tip){
            var result = false;
            if($.trim($codeInput.val()) === ''){
                this.errorTip($tip,tip);

                result = false;
            }else{
                result = true;
            }
            return result;
        },

           distributeType: function(type){
              switch(type)
              {
              case 'name':
                this.validateName($('#J_Name'),$('#J_ErrorTip'),'realName');
                break;
              case 'age':
                this.validateAge($('#J_Age'),$('#J_ErrorTip'),'请填写正确的年龄');
                break;
              default:
                break;
              }
           },

          getMaxMonth: function(date, value){
            date.setMonth(date.getMonth() + value);

            return date;
          },

          getCurTime: function(){
            axios.get(getUrl(config.url_map.time))
                .then(function(res) {
                      if(res.data.status.error_code === 0){
                            let curTime = res.data.bizobj.time;

                            let startTime = new Date(curTime).getTime() + 1 * 24 * 60 * 60 * 1000;

                            let endTime = this.getMaxMonth(new Date(curTime), 1).getTime();

                            $('#J_Date').mobiscroll().date({
                              theme: 'android-holo-light',
                              mode: 'scroller',
                              display: 'bottom',
                              lang: 'zh',
                              minDate: new Date(startTime),
                              maxDate: new Date(endTime)
                            });
                      }else{
                          this.errorTip($('#J_ErrorTip'),res.data.status.error_msg);
                      }
                  }.bind(this))
                  .catch(function(err) {
                    console.log(err);
                  });
          },

          submit: function (){

            var validateNameFlag = this.validateName($('#J_Name'),$('#J_ErrorTip'),'realName');
            if(!validateNameFlag){
                return false;
            }

            var validateAgeFlag = this.validateAge($('#J_Age'),$('#J_ErrorTip'),'请填写正确的年龄');
            if(!validateAgeFlag){
                return false;
            }

            var validateDateFlag = this.validateEmpty($('#J_Date'),$('#J_ErrorTip'),'请选择就医时间');
            if(!validateDateFlag){
                return false;
            }

            var validateHosFlag = this.validateEmpty($('#J_HospitalList_dummy'),$('#J_ErrorTip'),'请选择期望医院');
            if(!validateHosFlag){
                return false;
            }

            var validateDiseaseFlag = this.validateEmpty($('#J_DiseaseList_dummy'),$('#J_ErrorTip'),'请选择相关病症');
            if(!validateDiseaseFlag){
                return false;
            }

            if(validateDateFlag && validateNameFlag && validateAgeFlag && validateHosFlag && validateDiseaseFlag){
              if(!$('#J_OrderBtn').hasClass('disabled')){
                $('#J_OrderBtn').addClass('disabled');

                this.user.sid=this.login.sid;
                this.user.hospitalid = $('#J_HospitalList').val();
                this.user.illness = $('#J_DiseaseList').val();
                this.user.expecttime = $('#J_Date').val();
                this.user.tel=this.myInfo.tel;

                var formData = JSON.stringify(this.user);

               axios.post(getUrl(config.url_map.addAppointApplyOfsanye), JSON.parse(formData))
                  .then(function(res) {
                        if(res.data.status.error_code === 0){
                            window.location.href = '/#/orderSuccess';
                        }
                        else{
                            window.location.href = '/#/orderFail';
                        }

                        $('#J_OrderBtn').removeClass('disabled');
                    }.bind(this))
                  .catch(function(err) {
                    console.log(err);

                    $('#J_OrderBtn').removeClass('disabled');
                  });
              }
            }
          },

         getMyInfo: function(){
           var formData = JSON.stringify(this.login);           
           document.body.scrollTop =0;
           axios.post(getUrl(config.url_map.getUserInfo), JSON.parse(formData))
               .then(function(res) {
                   if(res.data.status.error_code === 0){
                       this.myInfo = res.data.bizobj;
                   }else if (res.data.status.error_code === 2){
                          window.location.href = '/#/login/orderSanye';
                   }else{
                        this.errorTip($('#J_ErrorTip'),res.data.status.error_msg);
                   }
               }.bind(this))
               .catch(function(err) {
                 console.log(err);
               });
       }
        },

        created: function(){
          this.getCurTime();
          this.getMyInfo();
          this.setHospital();
        },
        mounted:function(){
          this.initDiseaseSelect();
        }
}
</script>



// WEBPACK FOOTER //
// OrderSanye.vue?63820de1